import React, { PropTypes } from 'react';
import StyleButton from './StyleButton.js.jsx';

const BLOCK_TYPES = [
  {label: 'P', style: 'unstyled'},
  {label: <i key={'UL'} className="fa fa-list-ul"/>, style: 'unordered-list-item'},
  {label: <i key={'OL'} className="fa fa-list-ol"/>, style: 'ordered-list-item'},
];

const LimitedBlockStyleControls = (props) => {
  const {editorState} = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type, i) =>
        <StyleButton
          key={i}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          promptForLink={props.promptForLink}
          removeLink={props.removeLink}
        />
      )}
    </div>
  );
};

export default LimitedBlockStyleControls;



// WEBPACK FOOTER //
// global/components/forms/editorComponents/LimitedBlockStyleControls.js.jsx